"use client";
import { FaWhatsapp, FaFacebookSquare, FaInstagram, FaYoutube, FaPinterest } from 'react-icons/fa';
import { BsTwitterX } from 'react-icons/bs';
import ScrollToTop from '../scrollToTop';
import Image from 'next/image';
import Link from 'next/link';
import Script from 'next/script';
import $logo from '@assets/images/footer/logo.webp';

// Store
import useStore from '@store';

export default function Footer() {
	const $state = useStore();
	const { user } = $state?.auth || {};
	const role = user?.profile?.member_type.toLowerCase();
	const showKidSafeSeal = !['child', 'student'].includes(role);

	return (
		<>
			<footer className={`flex flex-col justify-between lg:flex-row relative bg-[#2222AA] p-8 gap-8 z-0 ${showKidSafeSeal ? '!pb-[88px]' : ''}`}>
				<ScrollToTop />
				<div className='flex flex-col gap-4'>
					<div className='flex flex-col gap-6'>
						<Link href='/' className='w-72'>
							<Image src={$logo} alt='MKTV Footer Logo' />
						</Link>
						{!['child','student'].includes(role) && (
							<nav className='flex flex-col sm:flex-row text-sm font-800 gap-4 sm:gap-8 mb-4'>
								<Link target='_blank' href='https://resources.muslimkids.tv/about/' className='text-[#EFEFEF]'>
									About Us
								</Link>
								<Link
									href='https://help.muslimkids.tv/hc/en-us'
									target='_blank'
									className='text-[#EFEFEF]'>
									Help Center
								</Link>
								<Link href='/help-center/terms-of-use' className='text-[#EFEFEF]'>
									Terms Of Use
								</Link>
								<Link href='/help-center/privacy-policy' className='text-[#EFEFEF]'>
									Privacy Policy
								</Link>
							</nav>
						)}
					</div>

					{!['child','student'].includes(role) && (
						<div className='flex flex-col gap-2'>
							<span className='text-[#EFEFEF] text-sm font-light'>Available on:</span>
							<Image
								className='w-full md:w-[600px]'
								width='1202'
								height='73'
								src='/images/general/streaming-logos.webp'
								alt='Streaming Platforms'
							/>
							<div className='flex flex-row gap-2 mt-2'>
								<a
									href='https://apps.apple.com/us/app/muslim-kids-tv/id1189900377'
									target='_blank'>
									<Image
										src='/images/footer/app-store.webp'
										width='132'
										height='39'
										alt='app-store'
									/>
								</a>
								<a
									href='https://play.google.com/store/apps/details?id=com.mktv.steelkiwi.muslimkidstv'
									target='_blank'>
									<Image
										src='/images/footer/google-play.webp'
										width='132'
										height='39'
										alt='google-play'
									/>
								</a>
							</div>
						</div>
					)}
					<div className='flex flex-col sm:flex-row items-center gap-6 mt-4'>

						{showKidSafeSeal && <div id='ksp-seals'></div>}
						<span className='text-[#9191E6] text-xs font-light'>
							© 2006 - {new Date().getFullYear()} Milo Productions Inc. All Rights
							Reserved
						</span>
					</div>
				</div>

				{!['child','student'].includes(role) && (
					<div className='text-white flex flex-col gap-2 lg:absolute lg:top-[40%] lg:right-0 lg:mr-8'>
						<span className='text-sm text-[#EFEFEF]'>Connect with us</span>
						<div className='flex flex-row items-center gap-4'>
							<a
								href='https://wa.me/+14038500293'
								className='size-8'
								target='_blank'
								aria-label='WhatsApp'>
								<FaWhatsapp size={22} />
							</a>
							<a
								href='https://instagram.com/muslimkids.tv/'
								className='size-8'
								target='_blank'
								aria-label='Instagram'>
								<FaInstagram size={22} />
							</a>
							<a
								href='https://twitter.com/muslim_kidstv'
								className='size-8'
								target='_blank'
								aria-label='Twitter/X'>
								<BsTwitterX size={22} />
							</a>
							<a
								href='https://youtube.com/user/miloproductionsinc'
								className='size-8'
								target='_blank'
								aria-label='YouTube'>
								<FaYoutube size={22} />
							</a>
							<a
								href='https://www.facebook.com/MuslimKidsTV'
								className='size-8'
								target='_blank'
								aria-label='Meta'>
								<FaFacebookSquare size={22} />
							</a>
							<a
								href='http://www.pinterest.com/MuslimKidsTV/'
								className='size-8'
								target='_blank'
								aria-label='Pinterest'>
								<FaPinterest size={22} />
							</a>
						</div>
					</div>
				)}
			</footer>
			{showKidSafeSeal && (
				<Script
					id='ksp-seals-script'
					data-product='CEAqK03bcKtQfJbxSpbD7MRN3yz3dN8wN46N5P2l'
					src='https://kidsafe.com/js/seals/seals.js'
					strategy='afterInteractive'
				/>
			)}
		</>
	);
}
